import ThumbBucketProfileCapacityView from './ThumbBucketProfileCapacityView';

export default class ThumbBucketProfileView {
  constructor(item) {
    if (item) {
      this.id = item.id;
      this.name = item.name;
      this.style = item.style;
      this.styleName = item.styleName;
      this.carrierId = item.carrierId;
      this.carrierName = item.carrierName;
      this.weightCategoryId = item.weightCategoryId;
      this.weightCategoryName = item.weightCategoryName;
      this.width = item.width;
      this.capacityUnits = item.capacityUnits;
      this.capacityUnitsName = item.capacityUnitsName;
      this.capacityConfigurations = item.capacityConfigurations.map(
        (x) => new ThumbBucketProfileCapacityView(x)
      );
      this.toothConfigurations = item.toothConfigurations;
      return;
    }
    this.id = '';
    this.name = '';
    this.style = null;
    this.styleName = '';
    this.carrierId = '';
    this.carrierName = '';
    this.weightCategoryId = '';
    this.weightCategoryName = '';
    this.width = 0;
    this.capacityConfigurations = [];
    this.toothConfigurations = [];
  }
}
